module.exports = __webpack_public_path__ + "static/media/getting-support@2x.993d2465.png";